import {
    useReactTable,
    getCoreRowModel,
    getSortedRowModel,
    getFilteredRowModel,
    getPaginationRowModel,
    ColumnFiltersState,
    SortingState,
} from "@tanstack/react-table";
import { useState } from "react";
import { TableHeaderCell } from "../commonTableComponents/tableHeaderCell";
import { TablePagination } from "../commonTableComponents/tablePagination";
import { PanelListTableBody } from "./panelListTableBody";
import { panelListColumns } from "./utils";
import { PanelListElement } from "../../../eventBus/panelListEventPayloads";
import "./panelListContent.css";

export const PanelListTable = ({ panelListEntities }: { panelListEntities: PanelListElement[] }) => {
    const [sorting, setSorting] = useState<SortingState>([{ id: "panelIdId", desc: false }]);
    const [columnFilters, setColumnFilters] = useState<ColumnFiltersState>([]);
    const [pageIndex, setPageIndex] = useState(0);
    const [pageSize, setPageSize] = useState(100);

    const table = useReactTable({
        data: panelListEntities,
        columns: panelListColumns,
        state: { sorting, columnFilters, pagination: { pageIndex, pageSize } },
        onSortingChange: setSorting,
        onColumnFiltersChange: setColumnFilters,
        getCoreRowModel: getCoreRowModel(),
        getSortedRowModel: getSortedRowModel(),
        getFilteredRowModel: getFilteredRowModel(),
        onPaginationChange: updater => {
            setPageIndex(() =>
                typeof updater === "function" ? updater({ pageIndex, pageSize }).pageIndex : updater.pageIndex,
            );
            setPageSize(() =>
                typeof updater === "function" ? updater({ pageIndex, pageSize }).pageSize : updater.pageSize,
            );
        },
        getPaginationRowModel: getPaginationRowModel(),
    });

    return (
        <div className="panel-list-table-wrapper">
            <TablePagination<PanelListElement> table={table} />

            <table className="panel-list-table">
                <thead>
                    {table.getHeaderGroups().map(headerGroup => (
                        <tr key={headerGroup.id}>
                            {headerGroup.headers.map(header => (
                                <TableHeaderCell key={header.id} header={header} />
                            ))}
                        </tr>
                    ))}
                </thead>

                <PanelListTableBody rows={table.getRowModel().rows} />
            </table>
        </div>
    );
};
